// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Menu: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16">
            <path
                fill="#0088C7"
                d="M23.0357143,20.9130435 L6.92812525,20.9130435 C6.43392869,20.9130435 6,21.3826082 6,21.9173916 C6,22.5304353 6.43392869,23 6.92812525,23 L23.0357143,23 C23.5660719,23 24,22.5304353 24,21.9956519 C24,21.3826082 23.5660719,20.9130435 23.0357143,20.9130435 Z M23.0357143,7 L6.92812525,7 C6.43392869,7 6,7.46956469 6,8.00434809 C6,8.53913017 6.43392869,9.08695652 6.92812525,9.08695652 L23.0357143,9.08695652 C23.5660719,9.08695652 24,8.61739184 24,8.08260843 C24,7.54782635 23.5660719,7 23.0357143,7 Z M23.0357143,13.9565217 L6.92812525,13.9565217 C6.43392869,13.9565217 6,14.4260871 6,15 C6,15.5739136 6.43392869,16.0434783 6.92812525,16.0434783 L23.0357143,16.0434783 C23.5660719,16.0434783 24,15.5739136 24,15 C24,14.4260864 23.5660719,13.9565217 23.0357143,13.9565217 Z"
                transform="translate(-6 -7)"
            />
        </svg>
    );
};

export default React.memo(Menu);
